// extracted by mini-css-extract-plugin
export default {"wrapper":"FreemiumEndedinfo__wrapper--j1b3i","content":"FreemiumEndedinfo__content--14oqU"};